export enum AffiliateNotificationType {
  AFFILIATE_REGISTERED = 'AFFILIATE_REGISTERED',
  NEW_PLAYER_REGISTERED = 'NEW_PLAYER_REGISTERED',
  COMMISSION_CALCULATED = 'COMMISSION_CALCULATED',
  WITHDRAW_REQUEST_APPROVED = 'WITHDRAW_REQUEST_APPROVED',
}

export interface IAffiliateNotification {
  id: number;
  name: string;
  subject: string;
  content: string;
  data: {
    playerId: number;
    affiliateId: number;
  };
  createdAt: number;
  seenAt: number | null;
  actionId: AffiliateNotificationType;
}
